import * as React from "react";
import { TextField, IconButton, Stack, Typography } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

export default function InlineEditableText({ value: initialValue, onChange }) {
  const [value, setValue] = React.useState(initialValue);
  const [editing, setEditing] = React.useState(false);
  const inputRef = React.useRef(null);

  // Keep internal state in sync if parent changes the value
  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  React.useEffect(() => {
    if (editing) {
      inputRef.current?.focus();
      inputRef.current?.select();
    }
  }, [editing]);

  const commit = () => {
    setEditing(false);
    onChange?.(value);
  };

  const cancel = () => {
    setValue(initialValue);
    setEditing(false);
  };

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      {!editing ? (
        <>
          <Typography variant="body1">{value || "—"}</Typography>

          {/* Always visible in read-only mode */}
          <IconButton
            size="small"
            onClick={() => setEditing(true)}
            aria-label="edit"
            sx={{backgroundColor:"#e0e0e0"}}
          >
            <MoreHorizIcon fontSize="small" />
          </IconButton>
        </>
      ) : (
        <TextField
          inputRef={inputRef}
          value={value}
          size="small"
          fullWidth
          variant="standard"
          onChange={(e) => setValue(e.target.value)}
          onBlur={commit}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              commit();
            }
            if (e.key === "Escape") {
              e.preventDefault();
              cancel();
            }
          }}
          sx={{
            minWidth: 120,
            "& .MuiInputBase-input": {
              fontSize: "1rem",
              padding: 0,
            },
          }}
        />
      )}
    </Stack>
  );
}